export const name = "UNIX_MILLIS";
export const summary = `Converts a \`TIMESTAMP\` value to the number of milliseconds since 1970-01-01 00:00:00 UTC.`;
export const reference = `
## UNIX_MILLIS

Converts a \`TIMESTAMP\` value to the number of milliseconds since 1970-01-01 00:00:00 UTC.

\`\`\`
UNIX_MILLIS(timestamp_expression)
\`\`\`

### Description

Returns the number of milliseconds since \`1970-01-01 00:00:00 UTC\`. Truncates higher levels of precision by rounding down to the beginning of the millisecond.


### Return Data Type

\`INT64\`


### Examples



\`\`\`
SELECT UNIX_MILLIS(TIMESTAMP "2008-12-25 15:30:00+00") AS millis;

/*---------------*
 | millis |
 +---------------+
 | 1230219000000 |
 *---------------*/
\`\`\`



\`\`\`
SELECT UNIX_MILLIS(TIMESTAMP "1970-01-01 00:00:00.0018+00") AS millis;

/*---------------*
 | millis |
 +---------------+
 | 1 |
 *---------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/timestamp_functions
`;
